/**
 * 缓存函数，和 Vue 中的 cached 函数类似
 * 但是这里缓存的对象是 Promise，并且可以控制缓存的时间
 * 当缓存时间设置为 undefined (默认值) 时，将永久缓存，等效于普通的 cached 函数
 * 
 * 返回和 promiseBuilder 函数功能相同的带有缓存功能的函数
 * promiseBuilder 的第一个输入参数将作为缓存的键值
 * 如果发现键值相同，将返回同一个返回值
 * @param {(arg:string)=>Promise} promiseBuilder 被缓存的函数 
 * @param {number} milliseconds 缓存失效时间 毫秒为单位 
 *                              从进入 settled 状态开始计时（无论成功失败） 
 *                              不填表示永不失效
 * 
 * @example
 * let getDate = cachedPromise(url => ajax.get(url));
 * getDate('localhost:8080/getTime').then(console.log) // 2019-10-14T07:56:41.612Z
 * getDate('localhost:8080/getTime').then(console.log) // 2019-10-14T07:56:41.612Z (和上一个结果完全一致)
 * 
 */
function cachedPromise(promiseBuilder, milliseconds) {
  let __currentPromise = {};

  function deleteCache(url) {
    // milliseconds 为 undefined 就永不失效
    if (milliseconds === undefined) {
      return;
    }
    setTimeout(() => {
      delete __currentPromise[url];
    }, milliseconds);
  }

  return function (url) {
    // 缓存
    if (__currentPromise[url]) {
      return __currentPromise[url]
    }
    // 这里连带删除操作一并缓存
    // 故而删除只触发一次
    // Promise-->delete-->call1
    //                |-->call2
    //                |-->call3
    __currentPromise[url] = promiseBuilder(url)
      .then(v => { // 无论成功失败都触发删除操作
        deleteCache(url);
        return v
      })
      .catch(err => {
        deleteCache(url);
        throw err;
      })
    return __currentPromise[url];
  }
}

export default {
  cachedPromise // 带有定时自动清除的 Promise 缓存功能
}